<template>
  <div class="shell-el">
<!--    <Logo
      class="logo-el md-under-d-none"
      :logo-url="logoUrl"
    />-->
    <div class="login-left md-under-d-none"
         :style="{backgroundImage: `url(${backgroundImage})`}"

    >
      <logo-line-pc
        class="logo-line pc-cpt"
      ></logo-line-pc>
    </div>
    <div class="login-right"
      :class="{'general': $route.name !== 'register'}"
    >
      <VuePerfectScrollbar
        class="scroll-VuePerfectScrollbar pt-4 pb-6"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="right-real-content">
          <slot class=""></slot>
        </div>
      </VuePerfectScrollbar>
    </div>
    <logo-line
      class="logo-line mobile-cpt"
    ></logo-line>
  </div>
</template>

<script>
import logoLine from "@/components/login/logoLine";
import logoLinePc from "@/components/login/logoLinePc";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import Logo from '@/layouts/components/Logo'
import defaultBgImage from '@/assets/images/loginbg.png'
export default {
  name: "fullPageShell",
  components: {
    Logo,
    logoLine,
    logoLinePc,
    VuePerfectScrollbar,
  },
  data() {
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      backgroundImage: defaultBgImage,
    }
  },
}
</script>

<style scoped lang="scss">

.shell-el {
  height: 100%;
  overflow-y: hidden;
  .login-left {
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .vs-row-shell,
  .vs-col-col {
    height: 100%;
  }
  .vs-row-shell {
    width: 100%;
  }

}

.login-right {
  .right-real-content {
    padding: 0 3rem;
    padding-top: 30px;
  }
  &.general {
  }
  .scroll-VuePerfectScrollbar {
    height: 100%;
  }

  .mobile-logo {

  }
}

</style>
<style lang="scss">
// pc
@media screen and (min-width: 768px) {
  .shell-el {
    .login-left {
      position: relative;
    }
      .pc-cpt {
        position: absolute;
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
      }

    .mobile-cpt {
      display: none;
    }
  }
  .login-right {
    &.general {
    }
  }

}
// 移动端
@media screen and (max-width: 768px){
  .shell-el {
    .pc-cpt {
      display: none;
    }
    .mobile-cpt {
      position: fixed;
      left: 30px;
      top: 20px;
    }
  }
}

@media screen and (min-width: 1200px){
  .shell-el {
    padding-right: 33.3%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .login-right {
    background-color: #ffffff;
    position: absolute;
    top: 0;
    right: 0;
    width: 33.3%;
    height: 100%;
  }
}

.shell-el {
  background-color: #ffffff;
}
.login-right {
  background-color: #ffffff;
}

@media screen and (max-width: 768px){
  .shell-el .login-right {
    height: 100%;
    .right-real-content {
      padding-top: 160px;
    }
  }
}
@media screen and (max-width: 1200px){
  .shell-el .login-right {
    .right-real-content {
      padding-top: 160px;
    }
  }
}
</style>

